/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var Site = /** @class */ (function () {
        function Site() {
        }
        Site.init = function () {
            new Site().run();
        };
        Site.prototype.run = function () {
            Site.initResponsiveVideo();
            Site.initResponsiveTables();
            Site.initFrontpage();
            Site.initOwlCarousel('.charts.carousel', {
                loop: false,
                dots: true,
                //pagination: true,
                margin: 85,
                //nav: true,
                //navText: ["flett1", "fletta2"],
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 2,
                    },
                    992: {
                        items: 3,
                    },
                    1440: {
                        items: 3,
                    }
                }
            });
            Site.initOwlCarousel('.card__container.carousel', {
                loop: false,
                //dots: true,
                nav: true,
                margin: 85,
                navText: ['<img src="/static/themes/main/images/arrow.svg">', '<img src="/static/themes/main/images/arrow.svg">'],
                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 2,
                    },
                    992: {
                        items: 2,
                    },
                    1440: {
                        items: 2,
                    }
                }
            });
            Site.initOneFilters();
        };
        Site.initOneFilters = function () {
            var $filter = $('#meetingBoxes select');
            if ($filter.length > 0) {
                $filter.on('change', function () {
                    window.location.href = $filter.val();
                });
            }
        };
        Site.initOwlCarousel = function (id, options) {
            var $owl = $(id);
            if ($owl.length > 0) {
                $owl.addClass('owl-carousel');
                $owl.owlCarousel(options);
            }
        };
        Site.is = function (bodyClass) {
            return document.body.classList.contains(bodyClass);
        };
        Site.initResponsiveVideo = function () {
            var iframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');
            Array.prototype.forEach.call(iframes, function (el) {
                var videoWrapper = document.createElement('div');
                videoWrapper.classList.add('video');
                videoWrapper.style.maxWidth = el.width;
                var responsiveWrapper = document.createElement('div');
                responsiveWrapper.classList.add('embed-responsive', 'embed-responsive-16by9');
                el.parentNode.insertBefore(responsiveWrapper, el);
                responsiveWrapper.appendChild(el);
                responsiveWrapper.parentNode.insertBefore(videoWrapper, responsiveWrapper);
                videoWrapper.appendChild(responsiveWrapper);
            });
        };
        Site.initResponsiveTables = function () {
            var tables = document.querySelectorAll('body:not(.admin) main table');
            Array.prototype.forEach.call(tables, function (el) {
                var responsiveWrapper = document.createElement('div');
                responsiveWrapper.classList.add('table-responsive');
                el.parentNode.insertBefore(responsiveWrapper, el);
                responsiveWrapper.appendChild(el);
            });
        };
        Site.initFrontpage = function () {
            if (!Site.is('frontpage')) {
                return;
            }
        };
        return Site;
    }());
    Site.init();

    exports.Site = Site;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
